import { render, staticRenderFns } from "./AddXmlStockList.vue?vue&type=template&id=c0385c7e"
import script from "./AddXmlStockList.vue?vue&type=script&lang=js"
export * from "./AddXmlStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports